export class TransactionStatus {
  orderTransactionId: string | undefined;
  pgmResponseCode: string | undefined;
  pgmResponseMessage: string | undefined;
  decision = 'REJECT';
  transactionStatus = 'DECLINED';
  transactionState = 'PAYMENT';
}

